import * as React from 'react'
import classes from './index.module.scss'

export const Width: React.FC<{
  width?: string
  children: React.ReactNode
}> = ({ width, children }) => {
  return (
    <div className={classes.width} style={{ '--input-width': `${width || 100}%` } as React.CSSProperties}>
      {children}
    </div>
  )
}
